// actions
import audienceId from '@/store/actions/audienceId'

export default {
  ...audienceId,
  setLang: (context, payload) => {
    context.commit('setLang', payload)
  },

  // Set presentation
  setSlide: (context, payload) => {
    context.commit('setSlide', payload)
  },

  // Update Presentation
  updateSlide: (context, payload) => {
    context.commit('updateSlide', payload)
  },

  // Set presentation
  setPresentation: (context, payload) => {
    context.commit('setPresentation', payload)
  },

  // Update Presentation
  updatePresentation: (context, payload) => {
    context.commit('updatePresentation', payload)
  },

}
